const filterStartHourOptions = (options, liveHours) => {
  if (!liveHours) {
    return options;
  }

  const hours = parseInt(liveHours.value, 10);

  const latestStartHour = 24 - hours;

  return options.filter((option) => {
    const optionHour = parseInt(option?.value?.split(':')[0], 10);
    return optionHour <= latestStartHour;
  });
};

export default filterStartHourOptions;
